document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

window.addEventListener('pageshow', () => {
  fetch('/cart.js').then(r => r.json()).then(cart => {
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
  }).catch(() => {});
});

document.addEventListener('DOMContentLoaded', () => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal major homepage/store elements as they enter the viewport.
  const revealTargets = document.querySelectorAll(
    '.value-item, .section-heading, .product-card, .category-panel, .footer-grid > *, .product-main > *, .cart-row, .rte-page'
  );
  revealTargets.forEach((el, index) => {
    el.classList.add('reveal-on-scroll');
    el.dataset.revealDelay = String(index % 4);
  });

  if (!reducedMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -35px' });
    revealTargets.forEach(el => observer.observe(el));
  } else {
    revealTargets.forEach(el => el.classList.add('is-visible'));
  }

  // Subtle hero parallax, desktop only.
  const hero = document.querySelector('.hero-metallic');
  const heroMedia = hero && hero.querySelector('.hero-media');
  if (!reducedMotion && hero && heroMedia && window.matchMedia('(min-width: 901px)').matches) {
    const updateParallax = () => {
      const rect = hero.getBoundingClientRect();
      const viewport = window.innerHeight || 800;
      if (rect.bottom > 0 && rect.top < viewport) {
        const progress = (viewport - rect.top) / (viewport + rect.height);
        const y = (progress - 0.5) * 34;
        heroMedia.style.transform = `scale(1.04) translate3d(0, ${y}px, 0)`;
      }
    };
    updateParallax();
    window.addEventListener('scroll', updateParallax, { passive: true });
  }

  // Give the header a glass/chrome feel after scrolling.
  const header = document.querySelector('.site-header');
  const updateHeader = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 24);
  };
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
});

// Compact mobile navigation.
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;

  const closeMenu = () => {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    menu.hidden = true;
  };

  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    toggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
    menu.hidden = open;
  });

  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  window.addEventListener('resize', () => { if (window.innerWidth > 1100) closeMenu(); });
});

// v10 product gallery: thumbnail switching + full-screen zoom/lightbox.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const stage = gallery.querySelector('[data-product-stage-image]') || gallery.querySelector('#ProductStageImage');
    const stageWrap = gallery.querySelector('[data-product-stage]') || gallery.querySelector('.product-stage');
    const thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));
    const lightbox = gallery.parentElement.querySelector('[data-product-lightbox]');
    const lightboxImage = lightbox && lightbox.querySelector('[data-product-lightbox-image]');
    const lightboxCanvas = lightbox && lightbox.querySelector('[data-product-lightbox-canvas]');
    let activeIndex = Math.max(0, thumbs.findIndex(t => t.classList.contains('is-active')));

    if (!stage) return;

    const setActiveImage = (index, openAfter = false) => {
      const thumb = thumbs[index];
      if (!thumb || !thumb.dataset.src) return;
      activeIndex = index;
      stageWrap && stageWrap.classList.add('is-loading');

      // Shopify image_tag outputs srcset. Remove it so changing src actually changes
      // the displayed image instead of the browser continuing to use the old srcset.
      stage.removeAttribute('srcset');
      stage.removeAttribute('sizes');
      stage.src = thumb.dataset.src;
      stage.alt = thumb.dataset.alt || stage.alt || '';

      thumbs.forEach((button, i) => {
        const selected = i === activeIndex;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      stage.addEventListener('load', () => stageWrap && stageWrap.classList.remove('is-loading'), { once: true });
      if (stage.complete) stageWrap && stageWrap.classList.remove('is-loading');
      if (openAfter) openLightbox();
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', event => {
        event.preventDefault();
        setActiveImage(index);
      });
    });

    const syncLightbox = () => {
      if (!lightboxImage) return;
      const activeThumb = thumbs[activeIndex];
      lightboxImage.src = (activeThumb && activeThumb.dataset.src) || stage.currentSrc || stage.src;
      lightboxImage.alt = stage.alt || '';
    };
    const openLightbox = () => {
      if (!lightbox || !lightboxImage) return;
      syncLightbox();
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      lightbox.classList.remove('is-zoomed');
      document.documentElement.classList.add('product-lightbox-open');
      document.body.classList.add('product-lightbox-open');
      const close = lightbox.querySelector('[data-product-lightbox-close]');
      close && close.focus({ preventScroll: true });
    };
    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      lightbox.classList.remove('is-zoomed');
      document.documentElement.classList.remove('product-lightbox-open');
      document.body.classList.remove('product-lightbox-open');
    };
    const step = direction => {
      if (!thumbs.length) return;
      activeIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
      setActiveImage(activeIndex);
      syncLightbox();
      lightbox && lightbox.classList.remove('is-zoomed');
      if (lightboxCanvas) { lightboxCanvas.scrollTop = 0; lightboxCanvas.scrollLeft = 0; }
    };

    gallery.querySelectorAll('[data-product-zoom]').forEach(button => button.addEventListener('click', openLightbox));
    stage.addEventListener('click', openLightbox);

    if (lightbox) {
      lightbox.querySelector('[data-product-lightbox-close]')?.addEventListener('click', closeLightbox);
      lightbox.querySelector('[data-product-lightbox-prev]')?.addEventListener('click', () => step(-1));
      lightbox.querySelector('[data-product-lightbox-next]')?.addEventListener('click', () => step(1));
      lightboxCanvas?.addEventListener('click', event => {
        if (event.target === lightboxImage || event.target === lightboxCanvas) lightbox.classList.toggle('is-zoomed');
      });
      lightbox.addEventListener('click', event => { if (event.target === lightbox) closeLightbox(); });
      document.addEventListener('keydown', event => {
        if (lightbox.hidden) return;
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') step(-1);
        if (event.key === 'ArrowRight') step(1);
      });
    }
  });
});
